import { isMoveDetailsValid } from '@/modules/yard/components/YardTasksCreateTaskMoveDetails.helpers';
import type { MoveTaskFormData } from '@nova/core';

/**
 * Validates task data before submission
 * @param taskData - Task data to validate
 */
export function validateTask(taskData?: MoveTaskFormData | null): boolean {
  if (!taskData) {
    console.error('No task data provided');
    return false;
  }

  if (taskData.type !== 'move') {
    console.error('Invalid task type');
    return false;
  }

  return isMoveDetailsValid(taskData.asset, taskData.destinationSpot);
}
